import { AccommodationSegmentLeg } from '@lp/features/RoutePlanner/components/RouteViewList/AccommodationSegmentLeg';
import { SegmentLegsList } from '@lp/features/RoutePlanner/components/RouteViewList/SegmentLegsList';
import { AccommodationLeg, AviaLegTypes, GroundLegTypes, RouteTypeEnum } from '@/api/apis/route';
import { RouteSegmentType } from '@/types/route';
import { getSegmentMapKey } from '@/utils/route';

type SegmentsListProps = {
  routeType: RouteTypeEnum;
  legs: Map<string, (AviaLegTypes | GroundLegTypes)[]>;
  accommodationLegs: Map<string, AccommodationLeg[]>;
  segments: RouteSegmentType[];
};

export const SegmentsList = ({ routeType, segments, legs, accommodationLegs }: SegmentsListProps) => {
  return (
    <div className="flex flex-col pt-1 gap-8 pb-8">
      {!segments.length && (
        <div className="flex justify-center items-center">
          <span className="text-m-m">Route legs not found.</span>
        </div>
      )}
      {segments.map((segment) => {
        const isAccommodation = !!segment.isAccommodation;

        if (isAccommodation) {
          const currentAccommodationLegs = accommodationLegs.get(getSegmentMapKey(segment)) || [];

          return currentAccommodationLegs.map((leg) => {
            return <AccommodationSegmentLeg key={leg.id} leg={leg} />;
          });
        }

        const segmentMainLegs = legs.get(getSegmentMapKey(segment)) || [];

        return (
          <SegmentLegsList
            key={segment.id}
            type="suggestion"
            routeType={routeType}
            legs={segmentMainLegs}
            segment={segment}
            isReadOnly
            isDisabled
            disableHintText="Please fill in the DONOR - TXC segment first"
          />
        );
      })}
    </div>
  );
};
